import type { MeResponse } from "@agw/contracts";
import { useQuery } from "@tanstack/react-query";
import { api } from "../../lib/endpoints";
import { qk } from "../../lib/query-keys";

export function useMe() {
  return useQuery({ queryKey: qk.me, queryFn: api.me, staleTime: 5 * 60_000, retry: 1 });
}

// UI gates only. The API enforces the same rules (packages/core/src/domain/policy.ts).
export const isAdmin = (me: MeResponse) => me.roles.includes("agw_admin");
export const isRep = (me: MeResponse) => me.roles.includes("sales_rep");
export const isManager = (me: MeResponse) => me.roles.includes("sales_manager");
export const isDealership = (me: MeResponse) => me.roles.includes("dealership");
export const canSubmit = (me: MeResponse) => isAdmin(me) || isRep(me);
export const canSeeReports = (me: MeResponse) => isAdmin(me) || isManager(me) || isDealership(me);
export const canManagePeople = (me: MeResponse) => isAdmin(me) || isManager(me);
/** Ops screens (failed syncs, imports): admins. */
export const isAgwStaff = isAdmin;
